const FACILITY_TYPE_LABELS = {
    SA: "Substance Abuse",
    MH: "Mental Health",
    HRSA: "Community Health",
    OTP: "Medication-Assisted",
};

function inferProgramType(name, facilityTypes = []) {
    const normalized = name.toLowerCase();

    if (
        normalized.includes("sober living") ||
        normalized.includes("recovery home") ||
        normalized.includes("transitional housing")
    ) {
        return "sober-living";
    }

    if (
        normalized.includes("outpatient") ||
        normalized.includes("iop") ||
        normalized.includes("php") ||
        facilityTypes.includes("OTP")
    ) {
        return "outpatient";
    }

    if (
        normalized.includes("inpatient") ||
        normalized.includes("residential") ||
        normalized.includes("detox") ||
        normalized.includes("rehab")
    ) {
        return "rehab";
    }

    if (facilityTypes.includes("MH") && !facilityTypes.includes("SA")) {
        return "resource";
    }

    if (facilityTypes.includes("HRSA")) {
        return "resource";
    }

    return "rehab";
}

function buildDescription(item) {
    const parts = [];

    if (item.location) {
        parts.push(item.location);
    }

    const locationLine = [item.city, item.state, item.zipCode].filter(Boolean).join(", ");
    if (locationLine) {
        parts.push(locationLine);
    }

    if (item.phone) {
        parts.push(`Phone: ${item.phone}`);
    }

    const website = item.website?.trim();
    if (website) {
        parts.push(`Website: ${website}`);
    }

    return parts.join(" · ") || "Treatment and recovery services.";
}

function buildTags(item, facilityTypes) {
    const tags = facilityTypes
        .map((type) => FACILITY_TYPE_LABELS[type] || type)
        .filter(Boolean);

    if (item.distanceMiles != null) {
        tags.push(`${item.distanceMiles.toFixed(1)} mi away`);
    }

    return tags.slice(0, 4);
}

function extractImageUrl(item) {
    const candidate =
        item.image ??
        item.imageUrl ??
        item.imageURL ??
        item.photo ??
        item.photoUrl ??
        item.thumbnail ??
        item.thumbnailUrl;

    if (typeof candidate !== "string") {
        return "";
    }

    return candidate.trim();
}

export function dedupeApiItems(items = []) {
    const grouped = new Map();

    for (const item of items) {
        const key = item.externalSourceKey || `${item.name}-${item.location}-${item.city}`;
        const existing = grouped.get(key);

        if (!existing) {
            grouped.set(key, {
                ...item,
                facilityTypes: item.facilityType ? [item.facilityType] : [],
            });
            continue;
        }

        if (item.facilityType && !existing.facilityTypes.includes(item.facilityType)) {
            existing.facilityTypes.push(item.facilityType);
        }
    }

    return [...grouped.values()];
}

export function mapApiItemToListing(item) {
    const facilityTypes = item.facilityTypes?.length
        ? item.facilityTypes
        : item.facilityType
          ? [item.facilityType]
          : [];
    const type = inferProgramType(item.name || "", facilityTypes);
    const stateName = item.state || "";

    return {
        id: item.externalSourceKey || `${item.name}-${item.location}-${item.city}`,
        name: item.name || "Treatment Center",
        type,
        city: item.city || "",
        state: stateName,
        description: buildDescription(item),
        tags: buildTags(item, facilityTypes),
        beds: null,
        verified: false,
        image: extractImageUrl(item),
        phone: item.phone || "",
        website: item.website?.trim() || "",
        address: item.location || "",
        zipCode: item.zipCode || "",
        distanceMiles: item.distanceMiles ?? null,
        facilityTypes,
        externalSourceKey: item.externalSourceKey || "",
    };
}

export function mapApiItemsToListings(items = []) {
    return dedupeApiItems(items).map(mapApiItemToListing);
}
